<script context="module" lang="ts">
	export interface SuggestionOption {
		street_line: string;
		city: string;
		state: string;
		zipcode: string;
		secondary: string;
	}
</script>

<script lang="ts">
	import { browser } from '$app/environment';

	export let shown = false;
	export let ShowConfirm = true;
	export let onClose: () => void = () => {};
	export let selectEnteredAddress: () => void;
	export let setSuggestedAddress: (suggestion: SuggestionOption) => void;
	//generate random GUID for ID
	export const id: string =
		Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
	let refStr = '';
	let modelObj: any;
	let modelEl: HTMLDivElement;
	let explaination: string = '';

	// Control modal visibility and body class
	$: {
		if (shown) {
			if (browser) {
				document.body.classList.add('modal-open');
			}
		} else {
			if (browser) {
				document.body.classList.remove('modal-open');
			}
		}
	}

	// Compute modal classes and styles based on 'shown' state
	$: modalClass = `modal fade ${shown ? 'show' : ''}`;
	$: modalStyle = shown ? 'display: block;' : 'display: none;';

	export function Hide() {
		if (!shown) return;
		shown = false;
		if (onClose) {
			onClose();
		}
		selectEnteredAddress();
		refStr = '';
	}
	export function SetRefStr(str: string) {
		refStr = str;
	}
	let address = '';
	let _suggestions: SuggestionOption[] = [];
	export function Show(
		street: string,
		city: string,
		state: string,
		zip: string,
		suggestions: SuggestionOption[],
		msg?: string
	) {
		if (msg) {
			explaination = msg;
		} else {
			explaination = '';
		}
		address = street + ', ' + city + ', ' + state + ' ' + zip;
		//Pick the first 3 suggestions where secondary = ''
		console.log(suggestions.filter((s) => s.secondary == ''));
		console.log(suggestions.filter((s) => s.secondary == '').slice(0, 3));
		_suggestions = suggestions.filter((s) => s.secondary == '').slice(0, 3);
		shown = true;
	}
</script>

<!-- Modal Backdrop -->
{#if shown}
	<div class="modal-backdrop fade show" />
{/if}

<div
	class={modalClass}
	{id}
	tabindex="-1"
	aria-labelledby="addressModalLabel"
	aria-hidden={!shown}
	role="dialog"
	style={modalStyle}
>
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="addressModalLabel">Select an Address</h5>
				<button
					class="btn-close"
					id="errorModelClose"
					type="button"
					on:click={Hide}
					aria-label="Close"
				/>
			</div>
			<div class="modal-body">
				{#if _suggestions.length > 0}
					<p>
						{#if explaination !== ''}{explaination}{:else}We are unable to validate the address.
							Select a valid address from the Suggested Addresses area or select the address you
							entered to confirm it is accurate.{/if}
					</p>
					<p>Suggested Addresses:</p>
					<div class="autocomplete-dropdown-container">
						<div class="autocomplete-dropdown open">
							<ul class="autocomplete-items-list">
								{#each _suggestions as suggestion, i}
									<!-- svelte-ignore a11y-click-events-have-key-events -->
									<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
									<li
										class="autocomplete-item blue_link"
										on:click={() => {
											setSuggestedAddress(suggestion);
										}}
									>
										{suggestion.street_line}{#if suggestion.city}, {suggestion.city}, {suggestion.state}
											{suggestion.zipcode}{/if}
									</li>
								{/each}
							</ul>
						</div>
					</div>
					<br />
				{:else}
					<p>
						We are unable to validate the address. Select the address you entered to confirm it is
						accurate.
					</p>
				{/if}
				<p>Address you entered:</p>
				<div class="autocomplete-dropdown-container">
					<div class="autocomplete-dropdown open">
						<ul class="autocomplete-items-list">
							<li
								class="autocomplete-item blue_link"
								data-value="0"
								on:click={selectEnteredAddress}
							>
								{address}
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
	.modal-body-centered {
		text-align: center;
	}
	.modal {
		z-index: 1050; /* Ensure the modal is always on top */
	}
	.modal-backdrop {
		z-index: 1040; /* Ensure the backdrop is below the modal */
	}
	.blue_link {
		color: blue;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
